/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EmailService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param email
     * @param reportId
     * @param token
     * @returns string
     * @throws ApiError
     */
    public unsubscribe(
        email: string,
        reportId: number,
        token: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/email/unsubscribe',
            query: {
                'email': email,
                'reportId': reportId,
                'token': token,
            },
        });
    }
}
